import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { SkillRatingConstituents } from '~/monolith-api';

export type GuideSkillsAssignee = {
   assigneeid: number;
   assigneetype: string;
   name: string;
   average_skill_rating: number;
   constituents: SkillRatingConstituents;
};

export type GetAssigneesSkilledInAGuideResponse = {
   assignees: GuideSkillsAssignee[];
   hasMore: boolean;
};

type AssigneeType = 'user' | 'team';

export type GetAssigneesSkilledInAGuideOptions = CommonRequestOptions & {
   query?: string;
   order?: 'DESC' | 'ASC';
   offset?: number;
   limit?: number;
   assignee_type?: AssigneeType | AssigneeType[];
};

export function getAssigneesSkilledInAGuide(
   guideid: number,
   options: GetAssigneesSkilledInAGuideOptions = {}
): Promise<GetAssigneesSkilledInAGuideResponse> {
   const { query, order, offset, limit, assignee_type, ...common } = options;

   return makeRequest('get', `/skills/guides/${guideid}/assignees`, {
      ...common,
      query: {
         query,
         order,
         offset,
         limit,
         assignee_type,
      },
   });
}
